import { FabricPlugin } from "../../FabricPlugin";

/**
 * @description class that is used by cell independent plugins to implement their state. Cell dependent plugins get their state from the GridCell
 */
export class PluginStateManager extends FabricPlugin {
    state = {
        selected: false, drawed: false, childSelected: false, readonly: false, active: false, disabled: false
    };

    constructor(options, ctx, data, state) {
        super(options, ctx, data);
        if (state) this.state = { ...this.state, ...state };
        super.hasOwnState = true;
    }

    updateState(state) {
        this.state = { ...this.state, ...state };
    }
}
